import React from "react";
import PropTypes from 'prop-types'

const ProgressTrackerBar = ({data}) => {
    return (
        <div className="progress-tracker-bar d-none d-md-flex">
            {data.map((item, key) => {
                return (
                    <div key={key} className={item.completed ? 'active' : ''}>
                        <div className="bar" />
                        <div className="title">{item.stepTitle}</div>
                    </div>
                )
            })}
        </div>
    )
}

ProgressTrackerBar.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        completed: PropTypes.bool.isRequired,
        stepTitle: PropTypes.string.isRequired,
    }))
}

export default ProgressTrackerBar;



// WEBPACK FOOTER //
// ./resources/js/modules/PendingConnection/ProgressTrackerBar.js